import React, { HTMLAttributes, useEffect, useState } from 'react'
import { MingcuteCloseFill } from '../icons/invalid'
import useModalStore from '@/store/modal.store'
type Props = HTMLAttributes<HTMLDivElement> & {
    children: React.ReactNode
}

const ModalBody = ({ children, className, ...props }: Props) => {
  const { onClose, isOpen } = useModalStore()
  const [isVisible, setIsVisible] = useState(false)
  const [isClosing, setIsClosing] = useState(false)

  useEffect(() => {
    if (isOpen) {
      setIsClosing(false)
      setIsVisible(true)
    } else if (isVisible) {
      setIsClosing(true)
      const timer = setTimeout(() => {
        setIsVisible(false)
        setIsClosing(false)
      }, 300)
      return () => clearTimeout(timer)
    }
  }, [isOpen, isVisible])

  return (
    <div 
      {...props} 
      className={`
        relative w-full max-w-[90vw] 
        md:max-w-[600px] max-h-[80vh] 
        overflow-auto border text-white 
        border-blue-500/15 bg-black 
        rounded-lg p-4 md:p-6 transition-transform 
        ${className}
        duration-300 ease-in-out transform ${
        !isVisible ? 'translate-y-full' : isClosing ? '-translate-y-full' : 'translate-y-0'
      }`}
    >
        <button className='absolute top-2 right-2 cursor-pointer hover:text-red-500 text-white' onClick={() => onClose()}>
            <MingcuteCloseFill />
        </button>
        {children}
    </div>
  )
}

export default ModalBody